<template>
  <v-text-field v-if="type === 'string'" :label="label" v-model="value" type="text" :rules="validationRules" :disabled="disabled" filled />
  <v-text-field
    v-else-if="type === 'number'"
    :label="label"
    v-model.number="value"
    type="number"
    :rules="validationRules"
    filled
    :disabled="disabled"
  />
</template>

<script>
import fieldMixin from '@/mixins/LeanField';

export default {
  name: 'LeanString',
  mixins: [fieldMixin],
  props: {
    type: {
      type: String,
      required: true
    }
  }
};
</script>
